// A technical workflow is used by the seeding only: a user never chooses it.
export const selectableWorkflowsOf = <
  W extends Readonly<{ isTechnical: boolean }>,
>(
  workflows: readonly W[],
): readonly W[] => workflows.filter(({ isTechnical }) => !isTechnical);
